import type { SystemStyleObject } from "@chakra-ui/react"

export const PATHICON_LIST_ITEM_ATTR = "data-pathicon"
export const PATHICON_CONTENT_ATTR = "data-pathicon-content"
export const PATHICON_MARKER_ATTR = "data-pathicon-marker"

export function getPathiconListItemClassName(value: unknown): string | null {
  if (typeof value !== "string") return null
  return (
    value
      .split(/\s+/)
      .filter((part) => /^pwai-[A-Za-z0-9_-]+$/.test(part))
      .join(" ") || null
  )
}

// Inline equivalents are serialized on new HTML so icons work outside HTMLText too.
export const PATHICON_ITEM_STYLE = "list-style-type:none;position:relative"
export const PATHICON_MARKER_STYLE =
  "position:absolute;inset-inline-start:-1.625em;top:0.2em;display:inline-block;width:1em;height:1em;color:inherit;line-height:1"
export const PATHICON_INLINE_STYLE =
  "display:inline-block;width:1em;height:1em;vertical-align:-0.125em;color:inherit;line-height:1"

export const PATHICON_LIST_STYLES: SystemStyleObject = {
  "& li[data-pathicon]": {
    listStyleType: "none",
    position: "relative",
    marginBlock: "0.2rem"
  },
  "& [data-pathicon-content] > p": { marginBlock: "0" },
  // Keep the complete legacy rule here: a duplicate selector in a consumer's
  // style object would be replaced (not merged) when these styles are spread.
  "& li[class^='pwai-'], & li[class*=' pwai-']": {
    listStyleType: "none",
    position: "relative",
    fontFamily: "var(--chakra-fonts-body) !important",
    fontWeight: 400,
    lineHeight: "1.4em",
    marginBlock: "0.2rem"
  },
  "& li[class^='pwai-']::before, & li[class*=' pwai-']::before": {
    position: "absolute",
    insetInlineStart: "-1.625em",
    fontFamily: "pathicons !important"
  },
  "& li[class^='pwai-'] > p, & li[class*=' pwai-'] > p": { marginBlock: "0" },
  "& .ProseMirror [data-pathicon-marker]": { cursor: "pointer" },
  "& [data-pathicon-marker]:focus-visible, & [data-pathicon-inline].ProseMirror-selectednode":
    {
      outline: "2px solid",
      outlineColor: "blue.500",
      outlineOffset: "2px"
    }
}
